/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import InvoiceemployeeItem from "components/invoices/InvoiceemployeeItem";
import { Trans } from "react-i18next";

class InvoiceemployeeTable extends Component {
    state = {
        sort_by: "trName", // training name by default
        sort_dir: "desc",
    };

    trName = "";
    trDate = "";
    trdocumentType = "";
    trfoPrice = "";
    employee = "";
    trposition = "";

    reOrder = (orderBy) => {
        let sort_dir = "asc";
        if (this.state.sort_dir === "asc") sort_dir = "desc";
        this.setState({
            sort_by: orderBy,
            sort_dir: sort_dir,
        });
    };

    setSotingClassNames = () => {
        this.trdocumentType = "";
        this.trName = "";
        this.employee = "";
        this.trfoPrice = "";
        this.trDate = "";
        this.trposition = "";

        switch (this.state.sort_by) {
            case "trdocumentType":
                this.trdocumentType = `_${this.state.sort_dir}`;
                break;
            case "trName":
                this.trName = `_${this.state.sort_dir}`;
                break;
            case "employee":
                this.employee = `_${this.state.sort_dir}`;
                break;
            case "trfoPrice":
                this.trfoPrice = `_${this.state.sort_dir}`;
                break;
            case "trDate":
                this.trDate = `_${this.state.sort_dir}`;
                break;
            case "trposition":
                this.trposition = `_${this.state.sort_dir}`;
                break;
            default:
                this.trName = `_${this.state.sort_dir}`;
                break;
        }
    };


    renderData = () => {

        const sorted = this.props.data;
        try {
            sorted = this.props.data.sort((a, b) => {
                switch (this.state.sort_by) {
                    case "trName":
                        return this.state.sort_dir === "desc"
                            ? a.company.name.localeCompare(b.company.name)
                            : b.company.name.localeCompare(a.company.name);
                    case "employee":
                        return this.state.sort_dir === "desc"
                            ? a.employee.name.localeCompare(b.employee.name)
                            : b.employee.name.localeCompare(a.employee.name);
                    case "trDate":
                        return this.state.sort_dir === "desc"
                            ? a.date - b.date
                            : b.date - a.date;
                    case "trfoPrice":
                        return this.state.sort_dir === "desc"
                            ? a.foPrice * a.foPrice - b.foPrice * b.foPrice
                            : b.foPrice * b.foPrice - a.foPrice * a.foPrice;
                    case "trposition":
                        return this.state.sort_dir === "desc"
                            ? a.position.name.localeCompare(b.position.name)
                            : b.position.name.localeCompare(a.position.name);
                    case "trdocumentType":
                        return this.state.sort_dir === "desc"
                            ? a.documentType.localeCompare(b.documentType)
                            : b.documentType.localeCompare(a.documentType);
                    default:
                        return this.state.sort_dir === "desc"
                            ? a.training.name.localeCompare(b.company.name)
                            : b.training.name.localeCompare(a.company.name);
                }
            });
        } catch { }

        return sorted.map((t) => {
            return <InvoiceemployeeItem key={t.key} inv={t} />;
        });
    };

    render() {
        this.setSotingClassNames();
        return (
            <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                id="kayitliEgitimler"
                style={{ display: "block" }}
            >
                <table
                    className="table display responsive tgE dataTable no-footer dtr-none collapsed"
                    id="dataTablePersonel"
                >
                    <thead>
                        <tr>
                            <th
                                onClick={() => this.reOrder("trDate")}
                                className={`all sorting${this.trDate}`}
                            >
                                <div className="tableTitle">
                                    <Trans desc="invoicedate">invoicedate</Trans>
                                </div>
                            </th>
                            <th
                                onClick={() => this.reOrder("trName")}
                                className={`all sorting${this.trName}`}
                            >
                                <div className="tableTitle">
                                    <Trans desc="invoicedealer">invoicedealer</Trans>
                                </div>
                            </th>
                            <DesktopBreakpoint>
                                <th
                                    onClick={() => this.reOrder("trposition")}
                                    className={`desktop sorting${this.trposition}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="invoiceposition">invoiceposition</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("employee")}
                                    className={`desktop sorting${this.employee}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="invoiceemployee">invoiceemployee</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trdocumentType")}
                                    className={`desktop sorting${this.trdocumentType}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="invoicedocumenttype">invoicedocumenttype</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trfoPrice")}
                                    className={`desktop sorting${this.trfoPrice}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="invoicefoprice">invoicefoprice</Trans>
                                    </div>
                                </th>

                            </DesktopBreakpoint>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData()}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default InvoiceemployeeTable;
